import React, { useState } from "react";
import { globals } from "../globals";
import SavedSearchPickerModal from "./SavedSearchPickerModal";
import CollectionsPickerModal from "./CollectionsPickerModal";
import './Toolbar.css';


export default function Toolbar({
  selectAll,
  deselectAll,
  addSelectedToCart,
  isAdmin,
  photosState,
  setPhotosState,
  collectionId
}) {
  const [pickerVisible, setPickerVisible] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);
  const [collectionPickerVisible, setCollectionPickerVisible] = useState(false);

  const deleteSelectedPhotos = async () => {
    const selectedFiles = photosState
      .filter(p => p.selected)
      .map(p => {
        const parts = p.src.split('/');
        const filename = parts.pop();
        parts.pop(); // rimuovi small/medium/large
        const folder = parts.pop();
        return { folder, filename };
      });

    if (selectedFiles.length === 0) return alert("Nessuna immagine selezionata.");
    if (!window.confirm("Confermi la cancellazione delle immagini selezionate?")) return;

    try {
      const response = await fetch(globals.homepageUrl + "/php/delete-file.php", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ files: selectedFiles })
      });

      const result = await response.json();
      if (result.success) {
        alert("Immagini cancellate con successo.");
        setPhotosState(prev =>
          prev.filter(p =>
            !result.deleted.some(d =>
              p.src.includes(`/${d.folder}/`) && p.src.endsWith(d.filename)
            )
          )
        );
      } else {
        alert("Errore: " + result.error);
      }
    } catch (err) {
      alert("Errore: " + err.message);
    }
  };

  const removeFromCollection = async () => {
    const selectedFiles = photosState
      .filter(p => p.selected)
      .map(p => {
        const parts = p.src.split('/');
        const filename = parts.pop();
        parts.pop(); // rimuove small/medium/large
        const folder = parts.pop();
        return { folder, filename };
      });

    if (selectedFiles.length === 0) return alert("Seleziona almeno una foto.");
    if (!window.confirm("Rimuovere le foto selezionate da questa collection? (non vengono cancellate dal sito)")) return;

    try {
      const response = await fetch(globals.homepageUrl + "/php/remove-from-collection.php", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ files: selectedFiles, collectionId: collectionId })
      });

      const result = await response.json();
      if (result.success) {
        alert(`Foto rimosse dalla collection: ${result.removed}`);
        // tolgo subito le foto dalla griglia
        setPhotosState(prev =>
          prev.filter(p =>
            !selectedFiles.some(f =>
              p.src.includes(`/${f.folder}/`) && p.src.endsWith(f.filename)
            )
          )
        );
      } else {
        alert("Errore: " + result.error);
      }
    } catch (err) {
      alert("Errore: " + err.message);
    }
  };

  const setCollectionCover = async () => {
  const selectedFiles = photosState
    .filter(p => p.selected)
    .map(p => {
      const parts = p.src.split('/');
      const filename = parts.pop();
      parts.pop(); // rimuove small/medium/large
      const folder = parts.pop();
      return { folder, filename };
    });

  if (selectedFiles.length !== 1) {
    alert("Seleziona una sola foto da usare come copertina.");
    return;
  }

  if (!window.confirm("Impostare la foto selezionata come copertina di questa collection?")) return;

  try {
    const response = await fetch(globals.homepageUrl + "/php/set-collection-cover.php", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ file: selectedFiles[0], collectionId: collectionId })
    });

    const result = await response.json();
    if (result.success) {
      alert("Copertina della collection aggiornata.");
      deselectAll();
    } else {
      alert("Errore: " + result.error);
    }
  } catch (err) {
    alert("Errore: " + err.message);
  }
};


  return (
  <div className="toolbar" >
{/* ------------------------ Funzioni per tutti gli utenti ------------------- */}
      <button onClick={selectAll} className="fa-button">
        <i className="fas fa-check"></i> Seleziona tutto
      </button>
      <button onClick={deselectAll} className="fa-button">
        <i className="fas fa-times"></i> Deseleziona tutto
      </button>
      <button
        onClick={addSelectedToCart}
        className="fa-button"
        style={{ backgroundColor: "#1890ff" }}
      >
        <i className="fas fa-cart-plus"></i> Aggiungi al carrello
      </button>

{/* ------------------------ Funzioni solo per admin ------------------- */}
      {isAdmin && (
        <>
{/* ------------------------ Setta thumbnail di galleria  ------------------- */}
          <button
            onClick={async () => {
              const selectedFiles = photosState
                .filter(p => p.selected)
                .map(p => {
                  const parts = p.src.split('/');
                  const filename = parts.pop();
                  parts.pop();
                  const folder = parts.pop();
                  return { folder, filename };
                });
              if (selectedFiles.length === 0) {
                alert("Seleziona almeno una foto.");
                return;
              }
              if (!window.confirm("Impostare la prima immagine selezionata come cover?")) return;

              try {
                const response = await fetch(globals.homepageUrl + "/php/set-featured.php", {
                  method: "POST",
                  headers: { "Content-Type": "application/json" },
                  body: JSON.stringify({ files: selectedFiles })
                });

                const result = await response.json();
                if (result.success) {
                  alert(`Immagine featured impostata: ${result.featured}`);
                } else {
                  alert("Errore: " + result.error);
                }
              } catch (err) {
                alert("Errore: " + err.message);
              }
            }}
            className="fa-button"
            style={{ backgroundColor: "#ff9900", color: "#fff" }}
          >
            <i className="fas fa-star"></i> Set gallery cover
          </button>

{/* ------------------------ Aggiungi ad una featured search  ------------------- */}

          <button
            onClick={async () => {
              const selectedFiles = photosState
                .filter(p => p.selected)
                .map(p => {
                  const parts = p.src.split('/');
                  const filename = parts.pop();
                  parts.pop();
                  const folder = parts.pop();
                  return { folder, filename };
                });

              if (selectedFiles.length === 0) {
                alert("Seleziona almeno una foto.");
                return;
              }

              if (!window.confirm("Vuoi impostare l'immagine selezionata come featured per una ricerca salvata?")) return;

              setSelectedImage(selectedFiles[0]);
              setPickerVisible(true);
            }}
            className="fa-button"
            style={{ backgroundColor: "#009933", color: "#fff" }}
          >
            <i className="fas fa-star"></i> Set as featured search
          </button>
  {/* ------------------------ Set as collection cover ------------------- */}
  {collectionId && (
    <button
      onClick={setCollectionCover}
      className="fa-button"
      style={{ backgroundColor: "#8f9900", color: "#fff" }}
    >
      <i className="fas fa-image"></i> Set as collection cover
    </button>
  )}

{/* ------------------------ Aggiungi ad una collection esistente  ------------------- */}

          <button
            onClick={async () => {
              const selectedFiles = photosState
                .filter(p => p.selected)
                .map(p => {
                  const parts = p.src.split('/');
                  const filename = parts.pop();
                  parts.pop();
                  const folder = parts.pop();
                  return { folder, filename };
                });

              if (selectedFiles.length === 0) {
                alert("Seleziona almeno una foto.");
                return;
              }

              if (!window.confirm("Vuoi aggiungere l'immagine selezionata ad una collection?")) return;

              setSelectedImage(selectedFiles);   // era selectedFiles[0]
              setCollectionPickerVisible(true);
            }}
            className="fa-button"
            style={{ backgroundColor: "#8a66ed", color: "#fff" }}
          >
            <i className="fas fa-star"></i> Add to collection
          </button>

          {collectionId && (
            <button
              onClick={removeFromCollection}
              className="fa-button"
              style={{ backgroundColor: "#b35900", color: "#fff" }}
            >
              <i className="fas fa-minus-circle"></i> Remove from collection
            </button>
          )}
{/* ---------------------------------------------------------------------------------- */}

          {pickerVisible && (
            <SavedSearchPickerModal
              onSelect={async (searchId) => {
                try {
                  const response = await fetch(globals.homepageUrl + "/php/set-featured-searches.php", {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify({
                      file: selectedImage,
                      searchId: searchId
                    })
                  });

                  const result = await response.json();
                  if (result.success) {
                    alert(`Immagine featured impostata per ricerca ID ${searchId}`);
                  } else {
                    alert("Errore: " + result.error);
                  }
                } catch (err) {
                  alert("Errore: " + err.message);
                } finally {
                  setPickerVisible(false);
                }
              }}
              onCancel={() => setPickerVisible(false)}
            />
          )}
          {collectionPickerVisible && (
            <CollectionsPickerModal
              onSelect={async (collectionId) => {
                try {
                  const response = await fetch(globals.homepageUrl + "/php/add-to-collection.php", {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify({
                      files: selectedImage,          // era: file: selectedImage
                      collectionId: collectionId
                    })
                  });

                  const result = await response.json();
                  if (result.success) {
                    alert(`Foto aggiunte: ${result.added}, già presenti: ${result.skipped}`);
                    deselectAll();                   // nuovo: azzera la selezione
                  } else {
                    alert("Errore: " + result.error);
                  }
                } catch (err) {
                  alert("Errore: " + err.message);
                } finally {
                  setCollectionPickerVisible(false);
                }
              }}
              onCancel={() => setCollectionPickerVisible(false)}
            />
          )}
                    <button
            onClick={async () => {
              const selectedFiles = photosState
                .filter(p => p.selected)
                .map(p => {
                  const parts = p.src.split('/');
                  const filename = parts.pop();
                  parts.pop(); // rimuove small/medium/large
                  const folder = parts.pop();
                  return { folder, filename };
                });

              if (selectedFiles.length === 0) {
                alert("Seleziona almeno una foto.");
                return;
              }

              if (!window.confirm("Vuoi elevare le immagini selezionate allo slider?")) return;

              try {
                const response = await fetch(globals.homepageUrl + "/php/ins-sld.php", {
                  method: "POST",
                  headers: { "Content-Type": "application/json" },
                  body: JSON.stringify({ files: selectedFiles }),
                });

                // Controlla prima che la risposta non sia vuota
                const text = await response.text();
                let result = {};
                try {
                  result = JSON.parse(text);
                } catch (e) {
                  console.error("Risposta non valida:", text);
                  alert("Errore: risposta non valida dal server");
                  return;
                }

                if (result.success) {
                  alert("Immagini aggiunte allo slider!");
                } else {
                  alert("Errore: " + (result.error || "Unknown error"));
                }
              } catch (err) {
                alert("Errore di rete o server: " + err.message);
              }
            }}
            className="fa-button"
            style={{ backgroundColor: "#6633cc", color: "#fff" }}
          >
            <i className="fas fa-angle-double-up"></i> Elevate to Slider
          </button>


          <button
            onClick={deleteSelectedPhotos}
            className="fa-button"
            style={{ backgroundColor: "#d9534f", color: "#fff" }}
          >
            <i className="fas fa-trash-alt"></i> Cancella foto
          </button>
        </>
      )}
    </div>
  );
}
